// extracted by mini-css-extract-plugin
export default {"acp-fulfilment-audit-log-list":"nCn9Vjhm3PYBHYn3781B","acp-fulfilment-audit-detail-message":"_cZgqGO3wfFGXMq4aAyQ"};